import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { XCircle, ArrowLeft, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/button';
import { trackEvent } from '../lib/analyticsEvents';

export default function PaymentCancelPage() {

  useEffect(() => {
    trackEvent('checkout_abandoned', {
      reason: 'payment_cancelled',
    });
  }, []);

  return (
    <main
      data-testid="payment-cancel-page"
      className="min-h-screen pt-20 bg-warm-alabaster flex items-center justify-center py-16"
    >
      <div className="max-w-md text-center px-6">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-amber-100 flex items-center justify-center animate-fade-in">
          <XCircle className="w-10 h-10 text-amber-600" />
        </div>

        <h1 className="font-serif text-3xl text-espresso font-semibold mb-4 animate-fade-in animate-stagger-1">
          Paiement annulé
        </h1>

        <p className="text-soft-charcoal-secondary mb-8 animate-fade-in animate-stagger-2">
          Votre paiement a été annulé. Votre panier a été conservé et vous pouvez
          réessayer quand vous le souhaitez.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center animate-fade-in animate-stagger-3">
          <Button asChild className="btn-primary">
            <Link to="/checkout">
              <RefreshCw className="mr-2 w-4 h-4" />
              Réessayer le paiement
            </Link>
          </Button>

          <Button asChild className="btn-secondary">
            <Link to="/menu">
              <ArrowLeft className="mr-2 w-4 h-4" />
              Continuer mes achats
            </Link>
          </Button>
        </div>

        <p className="text-xs text-soft-charcoal-secondary mt-8 animate-fade-in animate-stagger-4">
          Un problème ?{' '}
          <Link to="/contact" className="text-latte-gold hover:underline">
            Contactez-nous
          </Link>
        </p>
      </div>
    </main>
  );
}